import React from 'react'


function SelectUser(props) {

    function checkBox(){
       var tick =  document.querySelector("."+"v"+props.firstname.replace( /\s/g, ''));
       if(tick.checked){
        tick.checked=false;
        var arr = props.users.filter(item => item !== props.email);
        props.setUsers(arr);
       }
       else{
        tick.checked=true;
        props.setUsers(prev=>{
            return [...prev,props.email]
        })
       }
    }

    return (
        <div style={{userSelect:"none"}} onClick={checkBox} className="chatcard">
            <div title={props.firstname} className="userchatcard">
                <img className='chatprofile homeprofilepic' src={props.image || "images/defaultProfile.png"} alt="" />
                    <h3 className='selectUserH3'>{props.firstname}</h3>               
                <small><input type="checkbox" className={`v${props.firstname.replace( /\s/g, '')}`} name="checkbox" id="" /></small>
            </div>
            <hr className='hrcard' />
        </div>
    )
}

export default SelectUser